import React from "react";

import {
  Container,
  Box,
  Input,
  Button,
  InputLabel,
  Typography,
  InputAdornment,
  IconButton,
  // Customizable Area Start
  Paper,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Grid,
  Table,
  TableBody,
  TableRow,
  TableCell,
  styled,
  Snackbar,
  CircularProgress,
  // Customizable Area End
} from "@material-ui/core";

// Customizable Area Start
import { isArray } from "lodash";
import AutocompleteSelect from "../../../components/src/AutocompleteSelect.web";
import StyledInlineDatePicker from "../../../components/src/StyledInlineDatepicker.web";
import Alert from "@material-ui/lab/Alert";
import { colors } from "../../../blocks/utilities/src/Colors";
import { renderBaseOnConditions } from "../../utilities/src/CustomBlockHelpers";
// Customizable Area End

import SalesReportingController, {
  Props,
  configJSON,
  // Customizable Area Start
  ReportItem,
  SalesAndRevenueReport,
  DropdownType,
  RevenueReport,
  // Customizable Area End
} from "./SalesReportingController";

export default class SalesReporting extends SalesReportingController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
 renderTaskbar() {
  const { reportType, selectedYear, selectedWeekStartDay, selectedMonth } = this.state;
  const selectedReport = reportType?.option || '';
  const isSalesComparison = selectedReport === 'Sales Comparison Report';
  const isWeeklySalesReport = selectedReport === 'Weekly Sales Report';
  const isMonthlySalesReport = selectedReport === 'Monthly Sales Comparison Report';

  // Generate year options (current year and 5 years back)
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 6 }, (_, i) => ({
    id: String(currentYear - i),
    option: String(currentYear - i)
  }));
  return (
    <StyledWrapper>
      <Box sx={webStyle.taskbar} data-test-id={configJSON.taskbarTest}>
        <div className="reportSelectContainer">
          <AutocompleteSelect
            data-test-id="reportDropdown"
            placeholder="Select Report"
            fieldName="report"
            inputStyle={webStyle.autoCompleteInputStyle}
            options={this.state.reportList}
            value={reportType?.id || ''}
            disableClear={true}
            listBoxStyle={{ maxHeight: 310 }}
            onChange={(_blank: React.ChangeEvent<HTMLInputElement>, value: DropdownType | null) => {
              this.handleReportChange(value)
            }}
          />
        </div>
       <Box sx={webStyle.headerDropdown}>
      {isWeeklySalesReport ? (
        <>
          <Box sx={webStyle.weeklyDropdown}>
            <AutocompleteSelect
              data-test-id="yearDropdown"
              placeholder={configJSON.yearPlaceholder}
              fieldName="year"
              inputStyle={webStyle.autoCompleteInputStyle}
              options={yearOptions}
              value={String(selectedYear)}
              disableClear
              listBoxStyle={{ maxHeight: 200 }}
            onChange={(_blank: React.ChangeEvent<HTMLInputElement>, value: { id: string; option: string } | null) => {
                if (value) this.handleYearChange(Number(value.id));
              }}
            />
          </Box>
          <Box sx={webStyle.weeklyDropdown}>
            <AutocompleteSelect
              data-test-id="weekStartDayDropdown"
              placeholder={configJSON.weekStartDayPlaceholder}
              fieldName="weekStartDay"
              inputStyle={webStyle.autoCompleteInputStyle}
              options={configJSON.weekStartDayOptions}
              value={selectedWeekStartDay}
              disableClear
              listBoxStyle={{ maxHeight: 200 }}
            onChange={(_blank: React.ChangeEvent<HTMLInputElement>, value: { id: string; option: string } | null) => {
                if (value) this.handleWeekStartDayChange(value.id);
              }}
            />
          </Box>
        </>
      ) : isMonthlySalesReport ? (
        <>
          <Box sx={webStyle.weeklyDropdown}>
            <AutocompleteSelect
              data-test-id="yearDropdown"
              placeholder={configJSON.yearPlaceholder}
              fieldName="year"
              inputStyle={webStyle.autoCompleteInputStyle}
              options={yearOptions}
              value={String(selectedYear)}
              disableClear
              listBoxStyle={{ maxHeight: 200 }}
            onChange={(_blank: React.ChangeEvent<HTMLInputElement>, value: { id: string; option: string } | null) => {
                if (value) this.handleYearChange(Number(value.id));
              }}
            />
          </Box>
        <Box sx={webStyle.weeklyDropdown}>
          <AutocompleteSelect
            data-test-id="monthDropdown"
            placeholder={configJSON.monthPlaceHolder}
            fieldName="month"
            inputStyle={webStyle.autoCompleteInputStyle}
            options={configJSON.monthOptions}
            value={selectedMonth}
            listBoxStyle={{ maxHeight: 200 }}
            onChange={(
              _blank: React.ChangeEvent<HTMLInputElement>,
              value: { id: string; option: string } | null
            ) => {
              this.handleMonthChange(value ? value.id : "");
            }}
          />
        </Box>
        </>
      ) : (
       <>
          <Box sx={webStyle.datePicker}>
            <StyledInlineDatePicker
              data-test-id="fromDate"
              format="DD/MM/YYYY"
              placeholder={configJSON.fromDataPlaceholder}
              maxDate={new Date()}
              value={this.state.selectedFromDate || null}
              onChange={(date) => this.handleFromDateInput(date)}
              disableToolbar={false}
              openTo="date"
              views={["year", "month", "date"]}
            />
          </Box>
          <Box sx={webStyle.datePicker}>
            <StyledInlineDatePicker
              data-test-id="toDate"
              format="DD/MM/YYYY"
              placeholder={configJSON.toDatePlaceholder}
              minDate={this.state.selectedFromDate ? new Date(this.state.selectedFromDate) : undefined}
              maxDate={new Date()}
              value={this.state.selectedToDate || null}
              onChange={(date) => this.handleToDateInput(date)}
              disableToolbar={false}
              openTo="date"
              views={["year", "month", "date"]}
            />
          </Box>
          {isSalesComparison && (
            <>
              <Box sx={webStyle.datePicker}>
                <StyledInlineDatePicker
                  data-test-id="compareFromDate"
                  format="DD/MM/YYYY"
                  placeholder="Compare From Date"
                  maxDate={new Date()}
                  value={this.state.selectedCompareFromDate || null}
                  onChange={(date) => this.handleCompareFromDateInput(date)}
                  disableToolbar={false}
                  openTo="date"
                  views={["year", "month", "date"]}
                />
              </Box>

              <Box sx={webStyle.datePicker}>
                <StyledInlineDatePicker
                  data-test-id="compareToDate"
                  format="DD/MM/YYYY"
                  placeholder="Compare To Date"
                  minDate={this.state.selectedCompareFromDate ? new Date(this.state.selectedCompareFromDate) : undefined}
                  maxDate={new Date()}
                  value={this.state.selectedCompareToDate || null}
                  onChange={(date) => this.handleCompareToDateInput(date)}
                  disableToolbar={false}
                  openTo="date"
                  views={["year", "month", "date"]}
                />
              </Box>
            </>
          )}
        </>
      )}
     <Button
            data-test-id="PageHeaderButton"
            disabled={!this.validateFilters()}
            onClick={this.handleExport}
            style={webStyle.buttonStyle}
          >
            {this.state.showLoading ? (
              <CircularProgress
                disableShrink
                style={webStyle.loader}
                size={20}
                thickness={4}
                value={100}
              />
            ) : (
              configJSON.exportText
            )}
          </Button>
        </Box>
      </Box>
    </StyledWrapper>
  );
}

  renderFields(fields: any) {
    return (
      <Paper>
        <Box sx={webStyle.checkBoxFieldWrapper}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={
                    this.getAllTheCheckedColumns()?.length ===
                    this.state.filterFields.length
                  }
                  onChange={(e) =>
                    this.updateCheckbox(fields, null, true, "simpleFilter")
                  }
                />
              }
              label={configJSON.selectAll}
            />
            <Grid
              container
              spacing={2}
              direction='row'
              justify='flex-start'
              alignItems='flex-start'
            >
              {fields.map((elem: ReportItem) => (
                <Grid item xs={12} sm={6} md={3} key={elem.id}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={elem.checked}
                        onChange={(e) =>
                          this.updateCheckbox(
                            fields,
                            elem,
                            false,
                            "simpleFilter"
                          )
                        }
                      />
                    }
                    label={this.capitalizeFirstCharacter(elem.label)}
                  />
                </Grid>
              ))}
            </Grid>
          </FormGroup>
        </Box>
      </Paper>
    );
  }

  renderRevenueFields(filterField: RevenueReport) {
    return (
      <Paper>
        <Table style={{ minWidth: 650 }} aria-label='simple table'>
          <TableBody>
            <TableRow>
              <TableCell colSpan={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.checkIfAllFieldsChecked()}
                      onChange={(event) => {
                        this.selectAllRevenueFields(
                          filterField,
                          event.target.checked,
                          false
                        );
                      }}
                    />
                  }
                  label={configJSON.selectAll}
                />
              </TableCell>
            </TableRow>
            {Object.keys(filterField).map((key) => {
              if (key !== "total_for_each_column") {
                return (
                  <TableRow key={key}>
                    <TableCell component='th' scope='row'>
                      <Typography
                        style={{ wordWrap: "break-word", width: "8rem" }}
                      >
                        <strong>
                          {key === "other"
                            ? ""
                            : this.capitalizeFirstCharacter(key)}
                        </strong>
                      </Typography>
                    </TableCell>
                    <TableCell align='left'>
                      <FormGroup>
                        <Grid
                          container
                          spacing={2}
                          direction='row'
                          justifyContent='flex-start'
                          alignItems='flex-start'
                        >
                          {(filterField[key] as ReportItem[]).map(
                            (field: ReportItem, index: number) => (
                              <Grid item xs={4} key={index}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      data-test-d={`option-${index}-${key}`}
                                      checked={field.checked}
                                      onChange={() =>
                                        this.handleFilter(field, key, "")
                                      }
                                    />
                                  }
                                  label={this.capitalizeFirstCharacter(
                                    field.label
                                  )}
                                />
                              </Grid>
                            )
                          )}
                        </Grid>
                      </FormGroup>
                    </TableCell>
                  </TableRow>
                );
              } else {
                return (
                  <TableRow>
                    <TableCell colSpan={2}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={filterField[key] as boolean}
                            onChange={() =>
                              this.handleFilter(filterField[key], key, "")
                            }
                          />
                        }
                        label='Total for each Column'
                      />
                    </TableCell>
                  </TableRow>
                );
              }
            })}
          </TableBody>
        </Table>
      </Paper>
    );
  }
  renderFieldsCategoriesWise() {
    const { reportType, filterFields } = this.state;
    return (
      <Box>
        {configJSON.revenueFields.indexOf(
          reportType ? reportType.option : ""
        ) !== -1 &&
          this.renderRevenueFields(filterFields as SalesAndRevenueReport)}
        {configJSON.directFields.indexOf(
          reportType ? reportType.option : ""
        ) !== -1 && this.renderFields(filterFields)}
      </Box>
    );
  }
  getMultiSelectRenderValue(items: unknown) {
    let updatedLabels = this.handleUpdatedLabels(items);
    updatedLabels = updatedLabels || configJSON.stringsListPage_select_store;
    return isArray(items) && items.length === this.state.storeList.length ? (
      <span className='color_4D4D4D'>
        {configJSON.stringsListPage_all_stores}
      </span>
    ) : (
      updatedLabels
    );
  }

  // Customizable Area End

  render() {
    const {selectedGroup, selectedRegion, selectedFromDate, selectedToDate, selectedCompareFromDate,selectedCompareToDate,reportType, selectedStore, storeList, selectedYear, selectedWeekStartDay,selectedMonth} = this.state
    const isWeeklySalesReport = reportType?.option === 'Weekly Sales Report';
    const weekStartDayLabel = configJSON.weekStartDayOptions?.find((opt: { id: string; option: string }) => opt.id === selectedWeekStartDay)?.option || selectedWeekStartDay;
    const isMonthlySalesReport= reportType?.option === 'Monthly Sales Comparison Report';
    const monthLabel = configJSON.monthOptions?.find((opt: { id: string; option: string }) => opt.id === selectedMonth)?.option || selectedMonth;
    return (
      // Customizable Area Start
      <>
              <Box>
                {this.renderTaskbar()}
                <Box sx={webStyle.contentWrapper}>
                <Box sx={{...webStyle.taskbar, marginRight: 50}}>
                  <Box sx={{ maxWidth: 365, minWidth: 365 }}>
                   <Typography data-test-id="report-text">
                      <strong>Report Name :</strong> {reportType?.option}
                    </Typography>
                    {isWeeklySalesReport ? (
                      <Typography>
                        <strong>Year : </strong>{selectedYear} |{" "}
                        <strong>Week Start Day : </strong>{weekStartDayLabel}
                      </Typography>
                    ) : isMonthlySalesReport ? (
                      <Typography>
                        <strong>Year : </strong>{selectedYear} |{" "}
                        <strong>Month : </strong>{monthLabel}
                      </Typography>
                    ) : (
                      <Typography>
                        <strong>Period : </strong>
                        {`${this.formatDate(selectedFromDate)} _ ${this.formatDate(selectedToDate)}`}
                      </Typography>
                    )}
                  </Box>
                    <Box sx={webStyle.regionStoreDiv}>
                      <Typography><strong>Region :</strong> {'Selected Regions'}({selectedRegion.length})</Typography>
                      <Typography><strong>Stores :</strong>{`${selectedStore.length === storeList.length ? ' All Stores' : ' Selected Stores'}(${selectedStore.length})`}</Typography>
                      <Typography><strong>Groups :</strong>{'Selected Groups'}({selectedGroup.length})</Typography>
                    </Box>
                </Box>
                <StyleCustomizeBox>
                    <Button
                      data-test-id={configJSON.showOptionsTest}
                      disabled={!this.state.reportType}
                      onClick={this.handleShowFilter}
                      style={{...webStyle.buttonStyle, ...webStyle.customizeButtonStyle}}
                    >
                      {configJSON.customizeText}
                    </Button>
                  { renderBaseOnConditions(
                      this.state.isB2bActive,
                      <div className="reportSelectClientContainer">
                        <AutocompleteSelect
                          data-test-id='reportDropdown'
                          placeholder="Select Client"
                          fieldName="report"
                          inputStyle={webStyle.autoCompleteInputStyle}
                          options={this.state.reportList}
                          value={reportType?.id || ''}
                          disableClear={true}
                          listBoxStyle={{ maxHeight: 310 }}
                          onChange={(_blank: React.ChangeEvent<HTMLInputElement>, value: DropdownType | null) => {
                            this.handleReportChange(value)
                          }}
                        />
                      </div>,
                      <></>
                    )
                    }
                </StyleCustomizeBox>
                {
                  this.state.showFilterOptions && this.renderFieldsCategoriesWise()
                }
                </Box>
              </Box>
          
        <Snackbar
          anchorOrigin={{
            vertical: configJSON.top,
            horizontal: configJSON.center,
          }}
          autoHideDuration={2000}
          open={this.state.message.name !== ""}
          data-test-id='snack-bar'
          onClose={this.handleCloseSnackbar}
        >
          <Alert severity={this.state.message?.type}>
            {this.state.message?.name}
          </Alert>
        </Snackbar>
      </>
      // Customizable Area End
    );
  }
}

const StyledWrapper = styled("div")({
  "& .bordered-select": {
    minWidth: "260px",
    margin: "0 12px",
  },

  "& .reportSelectContainer": {
    margin: "0 12px",
    width: "40%",
    "@media only screen and (max-width: 1366px)": {
      minWidth: "40%",
    },
    "@media only screen and (max-width: 1280px)": {
      minWidth: "40%",
    },
    "@media only screen and (max-width: 1024px)": {
      minWidth: "32%",
    },
  },
});

const webStyle: any = {
  mainWrapper: {
    display: "flex",
    fontFamily: "Roboto-Medium",
    flexDirection: "column",
    alignItems: "center",
    paddingBottom: "30px",
    background: colors().white,
  },
  datePicker: {
    marginRight: 20,
    "& .react-datepicker__calendar-icon": {
      right: 0,
      padding: "0.4rem",
      fontSize: 18,
      color: colors().cyancobaltblue,
    },
    "& .react-datepicker__view-calendar-icon input": {
      padding: "10px 12px 10px 12px",
      width: "132px",
      borderRadius: "8px",
      border: `1px solid ${colors().lightborder}`,
      height: "37px",
      fontFamily: "Montserrat",
      fontSize: 13,
      transition: "border-color 0.2s ease, box-shadow 0.2s ease",
      "&:hover": {
        borderColor: colors().cyancobaltblue,
      },
      "&:focus": {
        outline: "none",
        borderColor: colors().cyancobaltblue,
        boxShadow: "0 0 0 3px rgba(32, 75, 156, 0.15)",
      },
    },
    // ---------- Calendar popup ----------
    "& .react-datepicker": {
      fontFamily: "Montserrat, Roboto, sans-serif",
      border: "none",
      borderRadius: 12,
      boxShadow: "0 8px 24px rgba(15, 23, 42, 0.12)",
      overflow: "hidden",
      color: "#0F172A",
    },
    "& .react-datepicker__triangle": {
      display: "none",
    },
    "& .react-datepicker__header": {
      backgroundColor: colors().white,
      borderBottom: "1px solid #EEF2F7",
      paddingTop: 14,
    },
    "& .react-datepicker__current-month, & .react-datepicker__header__dropdown": {
      fontWeight: 600,
      fontSize: 14,
      color: "#0F172A",
      marginBottom: 8,
    },
    "& .react-datepicker__day-name": {
      color: "#94A3B8",
      fontWeight: 600,
      fontSize: 12,
      width: "2rem",
      lineHeight: "2rem",
    },
    "& .react-datepicker__day": {
      width: "2rem",
      lineHeight: "2rem",
      borderRadius: 8,
      color: "#334155",
      transition: "background-color 0.15s ease, color 0.15s ease",
    },
    "& .react-datepicker__day:hover": {
      backgroundColor: "#EEF2FB",
      borderRadius: 8,
    },
    "& .react-datepicker__day--selected, & .react-datepicker__day--keyboard-selected": {
      backgroundColor: colors().cyancobaltblue,
      color: colors().white,
      fontWeight: 600,
      borderRadius: 8,
    },
    "& .react-datepicker__day--today": {
      fontWeight: 700,
      color: "#D7471D",
    },
    "& .react-datepicker__day--outside-month": {
      color: "#CBD5E1",
    },
    "& .react-datepicker__day--disabled": {
      color: "#E2E8F0",
    },
    "& .react-datepicker__navigation": {
      top: 14,
    },
    "& .react-datepicker__navigation-icon::before": {
      borderColor: "#94A3B8",
    },
    // Month & year dropdown lists (scrollable)
    "& .react-datepicker__year-dropdown, & .react-datepicker__month-dropdown": {
      backgroundColor: colors().white,
      border: "1px solid #EEF2F7",
      borderRadius: 10,
      boxShadow: "0 8px 24px rgba(15, 23, 42, 0.12)",
    },
    "& .react-datepicker__year-option:hover, & .react-datepicker__month-option:hover": {
      backgroundColor: "#EEF2FB",
    },
    "& .react-datepicker__year-option--selected_year, & .react-datepicker__month-option--selected_month": {
      backgroundColor: colors().cyancobaltblue,
      color: colors().white,
    },
  },
  weeklyDropdown: {
    marginRight: 20,
    minWidth: 180
  },
  headerDropdown: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: 2,
  },
  regionStoreDiv: {
    marginLeft: "150px",
    "@media only screen and (max-width: 1024px )": {
      marginLeft: "110px",
    },
  },
  taskbar: {
    display: "flex",
    paddingTop: 2,
  },
  contentWrapper: {
    marginTop: "10px",
    marginLeft: "12px",
    lineheight: 18,
  },
  checkBoxFieldWrapper: {
    padding: "10px",
  },
  branchDropdown: {
    minWidth: 200,
    margin: "0 12px",
  },
  autoCompleteInputStyle: {
    padding: "0px 10px 0px 6px",
    width: "auto",
    maxWidth: "350px",
  },
  buttonStyle: {
    height: "37px",
    padding: "6px 10px 6px 10px",
    fontWeight: "bolder",
    border: "none",
    borderRadius: "6px",
    textTransform: "none",
    backgroundColor: colors().lightgray,
  },
  customizeButtonStyle: {
    color: colors().cyancobaltblue,
    fontWeight: 600,
    marginBottom: 16,
    marginTop: 16,
  },
  loader: {
    color: colors().cyancobaltblue,
    animationDuration: "550ms",
  },
};

const StyleCustomizeBox = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  width: "60%",
  "& .reportSelectClientContainer": {
    minWidth: "30%",
    marginTop: "12px",
  },
  "@media only screen and (max-width: 1366px)": {
    width: "70%",
  },
  "@media only screen and (max-width: 1280px)": {
    width: "77%",
  },
  "@media only screen and (max-width: 1024px)": {
    width: "96%",
  },
});

// Customizable Area End
